var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.$t('teams_apps.welcome_to_apprentice_please_wait_one_moment_while_we_direct_you_to_the_right_page'))+".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }